// src/components/ForgotPassword.js
import React, { useState } from 'react';
import axios from 'axios';
import {
  Container,
  Heading,
  FormControl,
  FormLabel,
  Input,
  Button,
  Alert,
  AlertIcon,
  Divider,
  Flex,
} from '@chakra-ui/react';
import { useSectionBgGradient } from '../style/palette';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [serverMessage, setServerMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerMessage('');
    setErrorMessage('');

    try {
      const response = await axios.post('/api/forgot-password', { email });
      setServerMessage(response.data.message);
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message || 'Si è verificato un errore'
      );
    }
  };

  const bgGradient = useSectionBgGradient();

  return (
    <Container
      maxW="lg"
      mt={12}
      p={8}
      borderRadius="md"
      boxShadow="lg"
      bgGradient={bgGradient}
    >
      <Heading mb={4} fontSize="24px">
        Password Dimenticata?
      </Heading>
      <Divider mb={4} />
      {serverMessage && (
        <Alert status="success">
          <AlertIcon />
          {serverMessage}
        </Alert>
      )}
      {errorMessage && (
        <Alert status="error">
          <AlertIcon />
          {errorMessage}
        </Alert>
      )}
      {!serverMessage && (
        <Flex mt={4} width="100%">
          <form onSubmit={handleSubmit} style={{ width: '100%' }}>
            <FormControl mb={4} isRequired>
              <FormLabel>Email</FormLabel>
              <Input
                type="email"
                data-testid="forgot-password-email-input"
                placeholder="Inserisci l'email del tuo account"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                maxWidth="300px"
              />
            </FormControl>
            <Divider mb={4} mt={6} />
            <Flex width="100%" justifyContent="flex-end">
              <Button
                type="submit"
                colorScheme="blue"
                data-testid="forgot-password-submit-button"
              >
                Resetta Password
              </Button>
            </Flex>
          </form>
        </Flex>
      )}
    </Container>
  );
}

export default ForgotPassword;
